module.exports = __webpack_public_path__ + "static/wnetrze-3-pokojowe-mieszkanie-2-tablet-f365ec8d0902f64363207e56f8d4853c.jpg";